// apps/lc/src/mocks/wireframe/curriculum.ts
import type { Curriculum, CurriculumNode } from './types'

function chapters(prefix: string) {
  return [1, 2, 3, 4, 5].map(c => ({
    number: c,
    title: `${prefix} 챕터 ${c}`,
    lessons: [1, 2, 3, 4, 5, 6].map(l => ({
      number: l,
      title: `${prefix} ${c}-${l} 레슨`,
      avgAccuracyFirst: 55 + ((c * l) % 25),
      avgAccuracyFinal: 75 + ((c * l) % 20),
    })),
  }))
}

const PREFIX: Record<Curriculum, string> = {
  'core-a': '코어A',
  'core-b': '코어B',
  'core-c': '코어C',
  'prime-a': '프라임A',
  'prime-b': '프라임B',
  'prime-c': '프라임C',
}

export const CURRICULUMS: CurriculumNode[] = (Object.keys(PREFIX) as Curriculum[]).map(k => ({
  curriculum: k,
  chapters: chapters(PREFIX[k]),
}))

export const CURRICULUM_LABEL: Record<Curriculum, string> = {
  'core-a': '코어 A',
  'core-b': '코어 B',
  'core-c': '코어 C',
  'prime-a': '프라임 A',
  'prime-b': '프라임 B',
  'prime-c': '프라임 C',
}
